import { isClient } from '../ssr/is-client';
export const decodeBase64 = (value) => {
    if (isClient()) {
        return window.atob(value);
    }
    else {
        return Buffer.from(value, 'base64').toString();
    }
};
//# sourceMappingURL=decode-base64.js.map